import * as React from 'react';
import Loader from '../components/Loader';
import NotFound from './NotFound';
import EditCategory from './EditCategory';
import { useRequest, getHeaders } from '../api/client';
import { ProfileContext, ProfileManager } from '../profile';
import { RouteComponentProps } from 'react-router';

const category = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/categories/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.category : null;
};

const getEntityID = (props: RouteComponentProps<any>) => {
  return props.match.params.categoryId;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component category={preloadedEntity} />;
    }

    const state = category(getEntityID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component category={state.data} />;
  };
}

export default withState(EditCategory);
